// @ts-nocheck
import React, { useState, useEffect } from 'react';
import { getAuthUser } from '../utils/auth';
import '../Store/AllProducts.css';
import './OrderHistory.css';

const DigitalProductCard = ({ item, handleDownload }) => {
    const [currentImageIndex, setCurrentImageIndex] = React.useState(0);
    const product = item.displayData;

    // Logic to determine which images to use (prioritize displayImage for digital)
    let imagesToUse = [];
    if (product.displayImage && Array.isArray(product.displayImage) && product.displayImage.length > 0) {
        imagesToUse = product.displayImage;
    } else if (product.images && Array.isArray(product.images) && product.images.length > 0) {
        imagesToUse = product.images;
    }

    // Determine current image URL and Alt text
    let imageUrl = '';
    let imageAlt = item.title;

    if (imagesToUse && imagesToUse.length > 0) {
        const currentImage = imagesToUse[currentImageIndex];
        if (typeof currentImage === 'string') {
            imageUrl = currentImage;
        } else if (currentImage && typeof currentImage === 'object') {
            imageUrl = currentImage.url || '';
            imageAlt = currentImage.altText || item.title;
        }
    }

    const handlePrevious = (e) => {
        e.preventDefault();
        if (imagesToUse && imagesToUse.length > 1) {
            setCurrentImageIndex(prev => prev === 0 ? imagesToUse.length - 1 : prev - 1);
        }
    };

    const handleNext = (e) => {
        e.preventDefault();
        if (imagesToUse && imagesToUse.length > 1) {
            setCurrentImageIndex(prev => prev === imagesToUse.length - 1 ? 0 : prev + 1);
        }
    };

    return (
        <div className="product-card-wrapper flex w-full flex-col overflow-hidden rounded-[25px] border-[4px] border-slider bg-bg box-border transition-colors duration-200">
            <div className="product-card flex h-full flex-1 cursor-default flex-col text-inherit no-underline" style={{ cursor: 'default' }}>
                <div className="product-image-container relative flex w-full items-center justify-center overflow-hidden bg-[#f8f9fa] [aspect-ratio:1/1]">
                    {imageUrl ? (
                        <img 
                            className="image block h-full w-full object-cover" 
                            src={imageUrl} 
                            alt={imageAlt}
                        />
                    ) : (
                        <div className="no-image flex h-full w-full items-center justify-center border-b border-[#eee] bg-[#f8f9fa] text-[1.1rem] text-[#6c757d]">No Image</div>
                    )}
                    
                    {imagesToUse && imagesToUse.length > 1 && (
                        <div className="product-image-nav absolute bottom-[10px] right-[10px] z-[10] flex gap-[5px]">
                            <button 
                                className="product-nav-btn product-nav-prev flex h-[32px] w-[32px] items-center justify-center rounded-[10px] border border-slider bg-white/90 text-[#333] text-[12px] transition-all duration-300 hover:scale-110 hover:bg-white active:scale-95"
                                onClick={handlePrevious}
                            >
                                <i className="fi fi-rr-caret-left text-[14px] leading-none"></i>
                            </button>
                            <button 
                                className="product-nav-btn product-nav-next flex h-[32px] w-[32px] items-center justify-center rounded-[10px] border border-slider bg-white/90 text-[#333] text-[12px] transition-all duration-300 hover:scale-110 hover:bg-white active:scale-95"
                                onClick={handleNext}
                            >
                                <i className="fi fi-rr-caret-right text-[14px] leading-none"></i>
                            </button>
                        </div>
                    )}
                </div>
                <div className="Heading grow px-[1rem] pt-[1rem] pb-[0.25rem]">
                    <p className="title m-0 mb-[0.5rem] text-[1.1rem] font-[600] leading-[1.4] text-text">{item.title}</p>
                </div>
                <div className="price-container mb-[2px] flex items-center gap-[10px] px-[15px] pt-[2px] pb-[15px]">
                    {product.offerPrice && product.offerPrice !== product.price ? (
                        <>
                            <p className="price m-0 inline-block p-0 text-[1.4rem] font-[700] text-post-heading">₹{product.offerPrice}</p>
                            <p className="original-price-container m-0 inline-block text-[0.85em] font-[500] text-[#999]">
                                <span className="original-price line-through">₹{product.price}</span>
                                <span className="discount-percentage text-[0.95em]"> ({Math.round(((product.price - product.offerPrice) / product.price) * 100)}% OFF)</span>
                            </p>
                        </>
                    ) : (
                        <p className="price m-0 inline-block p-0 text-[1.4rem] font-[700] text-post-heading">₹{product.price}</p>
                    )}
                </div>
            </div>
            
            <div className="product-actions mt-auto flex justify-end gap-[10px] px-[15px] py-[10px]">
                <button 
                    className="buy-now-btn rounded-[6px] border-none bg-primary-cyan px-[20px] py-[10px] text-[0.9rem] font-[600] text-white"
                    onClick={() => handleDownload(product)}
                >
                     Download
                </button>
            </div>
        </div>
    );
};

const OrderHistory = () => {
    const [user, setUser] = useState(null);
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [guestOrderId, setGuestOrderId] = useState('');
    const [guestOrder, setGuestOrder] = useState(null);
    const [downloadProgress, setDownloadProgress] = useState(null); // eslint-disable-line no-unused-vars
    const [showGuestForm, setShowGuestForm] = useState(false);
    const [activeTab, setActiveTab] = useState('orders');
    const [selectedProductForDownload, setSelectedProductForDownload] = useState(null);
    const [downloadingFiles, setDownloadingFiles] = useState({});
    const [highlightedProductId, setHighlightedProductId] = useState(null);
    const [showAllReceipts, setShowAllReceipts] = useState(false);
    const [trackingOrder, setTrackingOrder] = useState(null);
    const [trackingStep, setTrackingStep] = useState(0);

    const getTrackingSteps = (order) => {
        if (!order || !order.trackingDetails || !order.trackingDetails.status) return [];
        const statusData = order.trackingDetails.status;
        if (Array.isArray(statusData)) {
            return statusData.filter(s => s.checked);
        }
        return [];
    };

    const handleRequestTracking = (order) => {
        const steps = getTrackingSteps(order);
        if (steps.length > 0) {
            setTrackingOrder(order);
            setTrackingStep(steps.length - 1); // Start at latest status
        } else {
            alert("No detailed tracking information available for this order yet.");
        }
    };

    // eslint-disable-next-line no-unused-vars
    const handleNextTrackingStep = () => {
        const steps = getTrackingSteps(trackingOrder);
        if (trackingStep < steps.length - 1) {
            setTrackingStep(prev => prev + 1);
        }
    };

    // eslint-disable-next-line no-unused-vars
    const handlePrevTrackingStep = () => {
        if (trackingStep > 0) {
            setTrackingStep(prev => prev - 1);
        }
    };

    const renderTrackingDisplay = () => {
        if (!trackingOrder) return null;
        const steps = getTrackingSteps(trackingOrder);
        const currentStatus = steps[trackingStep];

        if (!currentStatus) return null;

        return (
            <div className="order-tracking-display new-design relative mb-[2rem] rounded-none border border-slider bg-transparent p-[1rem] shadow-none">
                <h4 className="tracking-heading mb-[1rem] text-[0.9rem] font-[600] uppercase tracking-[0.5px] text-[#495057]">Status</h4>
                <div className="tracking-tabs-container flex items-start gap-[0.5rem] overflow-x-auto pb-[0.25rem]">
                    {steps.map((step, index) => {
                        const isActive = index === trackingStep;
                        return (
                            <div 
                                key={index} 
                                className={`tracking-tab-item flex min-w-[40px] shrink-0 cursor-pointer flex-col transition-all duration-300 ${isActive ? 'active min-w-[150px] grow' : ''}`}
                                onClick={() => setTrackingStep(index)}
                            >
                                <div className={`tab-number mb-[0.25rem] text-[0.9rem] transition-colors duration-300 ${isActive ? 'font-[600] text-[#47b5ff]' : 'text-[#495057]'}`}>{index + 1}.</div>
                                <div className={`tab-bar h-[3px] rounded-[2px] transition-all duration-300 ${isActive ? 'w-full bg-[#47b5ff]' : 'w-[30px] bg-[#dee2e6]'}`}></div>
                            </div>
                        );
                    })}
                </div>

                <div className="tab-content full-width mt-[0.25rem] animate-[fadeIn_0.4s_ease] pt-[0.5rem]">
                     <div className="tab-title mb-[0.35rem] text-[1.1rem] font-[700] text-[#47b5ff]">{currentStatus.status}</div>
                     {currentStatus.updatedAt && (
                         <div className="tab-date mb-[0.5rem] flex items-center gap-[6px] text-[0.8rem] font-[600] text-[#999]">
                             <i className="fi fi-rr-calendar-clock text-[14px]"></i>
                             <span>Updated on {formatDate(currentStatus.updatedAt)}</span>
                         </div>
                     )}
                     <div className="tab-message text-[0.9rem] leading-[1.5] text-[#6c757d]">{currentStatus.message}</div>
                </div>

                <button className="close-tracking-btn-simple mx-auto mt-[1rem] flex w-fit rounded-[10px] border-none bg-[#f8f9fa] p-[0.5rem] text-[1rem] font-[600] text-[#495057] transition-all duration-200 hover:bg-[#fa5a0a] hover:text-bg" onClick={() => setTrackingOrder(null)}>Close</button>
            </div>
        );
    };

    const [guestActiveTab, setGuestActiveTab] = useState('orders');

    const downloadFile = async (url, filename) => {
        // v3: Robust download sequence
        const proxyUrl = `${process.env.REACT_APP_API_URL}/images/download?url=${encodeURIComponent(url)}&filename=${encodeURIComponent(filename)}`;
        
        try {
            const response = await fetch(proxyUrl);
            
            if (!response.ok) {
                console.warn(`Backend proxy error ${response.status} for ${filename}`);
                window.open(url, '_blank');
                return;
            }

            const blob = await response.blob();
            const blobUrl = window.URL.createObjectURL(blob);
            
            const link = document.createElement('a');
            link.href = blobUrl;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setTimeout(() => window.URL.revokeObjectURL(blobUrl), 2000);

        } catch (error) {
            console.warn('Proxy download failed, reverting to direct open:', error);
            window.open(url, '_blank');
        }
    };

    const handleDownload = (productData) => {
        const images = productData.images;
        if ((images && Array.isArray(images) && images.length > 0) || productData.contentLink) {
            setSelectedProductForDownload(productData);
        } else {
            alert('No download content found for this product.');
        }
    };

    const triggerSingleDownload = async (fileUrl, title, index) => {
        if (!fileUrl) return;
        setDownloadingFiles(prev => ({ ...prev, [index]: true }));

        let extension = 'jpg';
        try {
                const path = new URL(fileUrl).pathname;
                const ext = path.split('.').pop();
                if (ext && ext.length < 5) extension = ext;
        } catch (e) {}
        
        const safeTitle = (title || 'download').replace(/[^a-z0-9]/gi, '_').toLowerCase();
        const filename = `${safeTitle}_${index + 1}.${extension}`;

        await downloadFile(fileUrl, filename);

        setTimeout(() => {
            setDownloadingFiles(prev => ({ ...prev, [index]: false }));
        }, 3000);
    };

    const handleGoToDownloads = (order, isGuest = false) => {
    // Find digital products in this order
    const digitalProducts = order.products.filter(p => {
         const pData = p.productId;
         if (pData && typeof pData === 'object' && pData.productType === 'digital') return true;
         if (p.productType === 'digital') return true;
         return false;
    });

    if (digitalProducts.length > 0) {
        if (isGuest) {
            setGuestActiveTab('digital');
        } else {
            setActiveTab('digital');
        }
        // Highlight the first one found
        const prodId = digitalProducts[0].productId && typeof digitalProducts[0].productId === 'object' && digitalProducts[0].productId._id;
        if (prodId) {
            setHighlightedProductId(prodId);
            setTimeout(() => setHighlightedProductId(null), 3000);
        }
    }
};

    const renderDownloadModal = () => {
        if (!selectedProductForDownload) return null;

        const product = selectedProductForDownload;
        const images = product.images || [];

        return (
            <div className="modal-overlay fixed left-0 top-0 z-[1000] flex h-full w-full items-center justify-center bg-black/50 backdrop-blur-[5px]" onClick={() => setSelectedProductForDownload(null)}>
                <div className="download-modal-content flex max-h-[85vh] w-[90%] max-w-[500px] flex-col rounded-[12px] bg-white px-[1.25rem] py-[1rem] shadow-[0_10px_40px_rgba(0,0,0,0.2)] animate-[modalSlideUp_0.3s_ease]" onClick={(e) => e.stopPropagation()}>
                    <div className="modal-header mb-[1.5rem] flex items-center justify-between border-b border-[#eee] pb-[1rem]">
                        <h3>{product.title}</h3>
                        <button className="close-modal-btn border-none bg-transparent p-0 text-[1.5rem] leading-[1] text-[#666] hover:text-slider-color" onClick={() => setSelectedProductForDownload(null)}>
                            &times;
                        </button>
                    </div>
                    
                    <div className="download-file-list flex max-h-[60vh] flex-col gap-[1rem] overflow-y-auto pr-[0.5rem]">
                        {images.map((img, index) => {
                             let rawUrl = (typeof img === 'string') ? img : (img.url || img.displayImage);
                             const fileTitle = (typeof img === 'object' && img.altText) ? img.altText : `File ${index + 1}`;

                             // Extract file extension from URL
                             let fileExt = '';
                             try {
                                 const path = new URL(rawUrl).pathname;
                                 const ext = path.split('.').pop();
                                 if (ext && ext.length < 6) fileExt = '.' + ext.toLowerCase();
                             } catch (e) {
                                 fileExt = '.file';
                             }

                             return (
                                <div key={index} className="download-file-item flex items-center justify-between rounded-[8px] border border-[#e9ecef] bg-[#f8f9fa] p-[1rem] transition-colors duration-200 hover:bg-[#f1f3f5]">
                                    <div className="file-info flex min-w-0 flex-1 items-center gap-[0.75rem]">
                                        <span className="file-ext-badge min-w-[36px] shrink-0 rounded-[4px] bg-slider px-[0.5rem] py-[0.3rem] text-center text-[0.7rem] font-[700] lowercase tracking-[0.5px] text-white">{fileExt}</span>
                                        <span className="file-name whitespace-normal break-words text-[0.8rem] font-[500] leading-[1.4] text-text" title={fileTitle}>{fileTitle}</span>
                                    </div>
                                    <button 
                                        className={`download-btn-small ml-[0.75rem] flex shrink-0 items-center justify-center rounded-[6px] border-none bg-slider p-[0.4rem] text-[1rem] text-white transition-all duration-300 hover:scale-[1.05] hover:bg-[#47b5ff] ${downloadingFiles[index] ? 'started cursor-default bg-[#28a745] hover:scale-100 hover:bg-[#28a745]' : ''}`}
                                        onClick={() => !downloadingFiles[index] && triggerSingleDownload(rawUrl, product.title, index)}
                                        disabled={downloadingFiles[index]}
                                    >
                                        {downloadingFiles[index] ? <i className="fi fi-ss-check-circle"></i> : <i className="fi fi-sr-down-to-line"></i>}
                                    </button>
                                </div>
                             );
                        })}

                        {product.contentLink && (
                             <div className="download-file-item flex items-center justify-between rounded-[8px] border border-[#e9ecef] bg-[#f8f9fa] p-[1rem] transition-colors duration-200 hover:bg-[#f1f3f5]">
                                <div className="file-info flex min-w-0 flex-1 items-center gap-[0.75rem]">
                                    <span className="file-icon shrink-0 text-[1.5rem] text-slider">🔗</span>
                                    <span className="file-name whitespace-normal break-words text-[0.8rem] font-[500] leading-[1.4] text-text">External Content Link</span>
                                </div>
                                <button 
                                    className="download-btn-small ml-[0.75rem] flex shrink-0 items-center justify-center rounded-[6px] border-none bg-slider p-[0.4rem] text-[1rem] text-white transition-all duration-300 hover:scale-[1.05] hover:bg-[#47b5ff]"
                                    onClick={() => window.open(product.contentLink, '_blank')}
                                >
                                    Open
                                </button>
                            </div>
                        )}
                    </div>
                    
                    <div className="mt-[1.5rem] text-center text-[0.9rem] text-[#666]" style={{ marginTop: '1.5rem', textAlign: 'center', fontSize: '0.9rem', color: '#666' }}>
                        <p>Click "Download" for each file you wish to save.</p>
                    </div>
                </div>
            </div>
        );
    };

    // Temporary fix for legacy orders where product data was stripped
    const LEGACY_ORDER_FIXES = {
        'ORDER_1771253223839_97bdf1b8h': [
            { productId: '69907aaf9d08073cd972d49c' }
        ]
    };

    useEffect(() => {
        const currentUser = getAuthUser();
        if (currentUser) {
            setUser(currentUser);
        } else {
            setUser(null);
        }
    }, []);

    useEffect(() => {
        if (user) {
            fetchUserOrders();
        } else {
            // Clear all data when user logs out
            setOrders([]);
            setGuestOrder(null);
            setActiveTab('orders');
            setSelectedProductForDownload(null);
            setDownloadingFiles({});
        }
    }, [user]); // eslint-disable-line react-hooks/exhaustive-deps

    // Scroll to highlighted product when it changes
    useEffect(() => {
        if (highlightedProductId) {
            // Small timeout to allow DOM to update after tab switch
            setTimeout(() => {
                const element = document.getElementById(`product-${highlightedProductId}`);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            }, 100);
        }
    }, [highlightedProductId, activeTab, guestActiveTab]);

    const fetchUserOrders = async () => {
        if (!user) return;
        setLoading(true);
        setError(null);
        
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/store/orders/user/${user._id}`);
            const result = await response.json();
            
            if (result.success) {
                let fetchedOrders = result.data;
                const patchOrders = async (ordersToPatch) => {
                    return Promise.all(ordersToPatch.map(async (order) => {
                        if (LEGACY_ORDER_FIXES[order.orderId]) {
                            const fixData = LEGACY_ORDER_FIXES[order.orderId];
                            const productPromises = fixData.map(async (fixItem, i) => {
                                try {
                                    const prodRes = await fetch(`${process.env.REACT_APP_API_URL}/store/products/${fixItem.productId}`);
                                    const prodResult = await prodRes.json();
                                    
                                    if (prodResult.success) {
                                        const fullProduct = prodResult.data;
                                        const existingProduct = (order.products && order.products[i]) ? order.products[i] : {
                                            quantity: 1,
                                            price: fullProduct.price,
                                            subtotal: fullProduct.price
                                        };

                                        return {
                                            ...existingProduct,
                                            productId: fullProduct,
                                            title: fullProduct.title
                                        };
                                    }
                                } catch (e) {
                                    console.error("Error patching product:", e);
                                }
                                return (order.products && order.products[i]) ? order.products[i] : null;
                            });

                            const patchedProducts = await Promise.all(productPromises);
                            return { ...order, products: patchedProducts.filter(Boolean) };
                        }
                        return order;
                    }));
                };

                const finalOrders = await patchOrders(fetchedOrders);
                setOrders(finalOrders);
            } else {
                setError(result.message || 'Failed to fetch orders');
            }
        } catch (err) {
            setError('Failed to fetch orders. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const fetchGuestOrder = async (e) => {
        e.preventDefault();
        if (!guestOrderId.trim()) {
            setError('Please enter an order ID');
            return;
        }

        setLoading(true);
        setError(null);
        setGuestOrder(null);
        setTrackingOrder(null);

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/store/orders/${guestOrderId.trim()}`);
            const result = await response.json();

            if (result.success) {
                setGuestOrder(result.data);
            } else {
                setError(result.message || 'Order not found');
            }
        } catch (err) {
            setError('Failed to fetch order details. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const getStatusColor = (status) => {
        const statusLower = status ? status.toLowerCase() : '';
        switch (statusLower) {
            case 'confirmed':
            case 'paid':
                return '#28a745';
            case 'placed':
            case 'pending':
                return '#ffc107';
            case 'cancelled':
            case 'failed':
                return '#dc3545';
            case 'shipped':
                return '#17a2b8';
            case 'delivered':
                return '#28a745';
            default:
                return '#6c757d';
        }
    };

    // eslint-disable-next-line no-unused-vars
    const getStatusIcon = (status) => {
        const statusLower = status ? status.toLowerCase() : '';
        switch (statusLower) {
            case 'confirmed':
            case 'paid':
                return '✓';
            case 'placed':
            case 'pending':
                return '⏳';
            case 'cancelled':
            case 'failed':
                return '❌';
            case 'shipped':
                return '🚚';
            case 'delivered':
                return '✅';
            default:
                return '❓';
        }
    };

    const formatPrice = (price, currency = 'INR') => {
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: currency
        }).format(price);
    };

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString('en-IN', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const getDigitalProducts = () => {
        const digitalItems = [];
        const processedIds = new Set();
        
        orders.forEach(order => {
            const statusLower = order.orderStatus ? order.orderStatus.toLowerCase() : '';
            const paymentStatusLower = (order.payment && order.payment.status) ? order.payment.status.toLowerCase() : '';
            
            const isPaid = ['confirmed', 'paid', 'delivered'].includes(statusLower) || 
                           ['paid'].includes(paymentStatusLower);

            if (isPaid && order.products) {
                order.products.forEach((product, index) => {
                    const productData = (product.productId && typeof product.productId === 'object') ? product.productId : {};
                    const isDigital = productData.productType === 'digital' || product.productType === 'digital';
                    const title = productData.title || product.title;
                    
                    if (isDigital) {
                        const uniqueId = productData._id || index;
                        
                        if (!processedIds.has(uniqueId)) {
                             processedIds.add(uniqueId);
                             digitalItems.push({
                                 displayData: productData,
                                 purchaseDate: order.createdAt,
                                 orderId: order.orderId,
                                 title: title
                             });
                        }
                    }
                });
            }
        });
        return digitalItems;
    };

    const renderDigitalProducts = () => {
        const digitalProducts = getDigitalProducts();

        if (digitalProducts.length === 0) {
            return (
                <div className="no-orders p-[3rem] text-center text-text">
                    <h2>No Digital Products Found</h2>
                    <p>You haven't purchased any digital items yet.</p>
                    <a href="/store?category=digital" className="shop-now-btn inline-block rounded-[6px] bg-slider px-[24px] py-[12px] font-[600] text-bg no-underline transition-all duration-300 hover:-translate-y-[1px] hover:bg-post-heading">Browse Digital Store</a>
                </div>
            );
        }

        return (
            <div className="all-product-area mx-auto grid w-full max-w-full gap-[1.5rem] p-[1.5rem] box-border">
                {digitalProducts.map((item, index) => (
                    <div 
                        key={index}
                        id={`product-${item.displayData._id}`}
                        className={highlightedProductId === item.displayData._id ? 'highlight-wrapper' : ''}
                    >
                        <DigitalProductCard 
                            item={item} 
                            handleDownload={handleDownload} 
                        />
                    </div>
                ))}
            </div>
        );
    };

    const renderOrderDetails = (order, isGuest = false) => {
        const subtotal = order.products.reduce((acc, curr) => acc + (curr.subtotal || 0), 0);
        const discount = subtotal - order.totalAmount;
        
        const hasDigital = order.products.some(p => {
            const pd = p.productId;
            if (pd && typeof pd === 'object' && pd.productType === 'digital') return true;
            if (p.productType === 'digital') return true;
            return false;
        });

        const hasPhysical = order.products.some(p => {
            const pd = p.productId;
            // Assuming default is physical if not specified as digital
            if (pd && typeof pd === 'object' && pd.productType === 'digital') return false;
            if (p.productType === 'digital') return false;
            return true;
        });

        const isConfirmed = ['confirmed', 'paid', 'delivered'].includes((order.orderStatus || '').toLowerCase());
        const isPaid = ((order.payment && order.payment.status) || '').toLowerCase() === 'paid';

        return (
        <div key={order._id} className="receipt-card relative flex w-full flex-col rounded-[2px] border border-[#eee] bg-[#fdfdfd] p-[1.5rem] font-['Courier_New',Courier,monospace] text-[#333] shadow-[0_4px_12px_rgba(0,0,0,0.05)] box-border">
            <div className="receipt-header mb-[1rem] text-center">
                <h3>HARIVISHNU.IN</h3>
                <p>Order Receipt</p>
                <div className="receipt-divider my-[0.8rem] h-[1px] border-b border-dashed border-[#bbb]"></div>
            </div>

            <div className="receipt-meta">
                <p className="my-[0.3rem] flex flex-col gap-[0.2rem] break-all text-[0.8rem] min-[481px]:flex-row min-[481px]:justify-between min-[481px]:gap-[1rem] min-[481px]:break-words"><strong>Order #:</strong> {order.orderId}</p>
                <p className="my-[0.3rem] flex flex-col gap-[0.2rem] break-all text-[0.8rem] min-[481px]:flex-row min-[481px]:justify-between min-[481px]:gap-[1rem] min-[481px]:break-words"><strong>Date:</strong> {formatDate(order.createdAt)}</p>
                <p><strong>Status:</strong> <span style={{ color: getStatusColor(order.orderStatus) }}>{order.orderStatus}</span></p>
            </div>
            
            <div className="receipt-divider my-[0.8rem] h-[1px] border-b border-dashed border-[#bbb]"></div>

            <div className="receipt-items">
                {order.products.map((product, index) => {
                    const productData = product.productId || {};
                    const title = productData.title || product.title || 'Product';
                    
                    return (
                        <div key={index} className="receipt-item-row">
                            <div className="item-name">
                                {title} <span className="item-qty">x{product.quantity}</span>
                            </div>
                            <div className="item-price">
                                {formatPrice(product.subtotal, order.currency)}
                            </div>
                        </div>
                    );
                })}
                {discount > 0 && (
                    <div className="receipt-item-row" style={{ color: '#28a745' }}>
                        <div className="item-name">Discount</div>
                        <div className="item-price">-{formatPrice(discount, order.currency)}</div>
                    </div>
                )}
            </div>

            <div className="receipt-divider my-[0.8rem] h-[1px] border-b border-dashed border-[#bbb]"></div>

            <div className="receipt-summary">
                <div className="summary-row">
                    <span>TOTAL</span>
                    <span className="summary-total">{formatPrice(order.totalAmount, order.currency)}</span>
                </div>
                <div className="summary-row-small">
                    <span>Payment:</span>
                    <span style={{ color: getStatusColor(order.payment && order.payment.status) }}>{(order.payment && order.payment.status) || 'Pending'}</span>
                </div>
                <div className="summary-row-small">
                    <span>Method:</span>
                    <span>{(order.payment && order.payment.method) || 'N/A'}</span>
                </div>
            </div>



            <div className="receipt-divider my-[0.8rem] h-[1px] border-b border-dashed border-[#bbb]"></div>

            {hasPhysical && order.trackingDetails && order.trackingDetails.status && order.trackingDetails.status.length > 0 && (
                 <div className="mb-[1rem] text-center" style={{ textAlign: 'center', marginBottom: '1rem' }}>
                    <button 
                        className="request-tracking-btn mt-[10px] inline-block rounded-[4px] border border-[#17a2b8] bg-white px-[1rem] py-[0.5rem] text-[0.9rem] text-[#17a2b8] transition-all duration-200 hover:bg-[#17a2b8] hover:text-white"
                        onClick={() => handleRequestTracking(order)}
                    >
                        Request Tracking
                    </button>
                 </div>
            )}

            {hasDigital && (isConfirmed || isPaid) && (
                <div className="mb-[1rem] text-center" style={{ textAlign: 'center', marginBottom: '1rem' }}>
                    <button 
                        className="receipt-download-btn rounded-[2px] border border-[#333] bg-transparent px-[1.5rem] py-[0.5rem] text-[0.9rem] font-[700] uppercase transition-all duration-300 hover:bg-[#333] hover:text-white"
                        onClick={() => handleGoToDownloads(order, isGuest)}
                    >
                        View
                    </button>
                </div>
            )}

            <div className="receipt-footer mt-auto pt-[0.5rem] text-center">
                <p>Thank you for your order!</p>
                <p>Save this receipt.</p>
                {/* <div className="receipt-barcode">||| || ||| || ||||</div> */}
            </div>
        </div>
        );
    };

    if (!user && !showGuestForm) {
        return (
            <div className="order-history-container mx-auto my-[4rem] w-[95%] max-w-[1000px] box-border rounded-[12px] bg-bg p-[2rem]">
                <div className="history-header mb-[3rem] text-center">
                    <h1>Order History</h1>
                    <p>View your order details and track delivery status</p>
                </div>

                <div className="guest-access-section mb-[2rem] rounded-[8px] bg-[#f8f9fa] p-[2rem] text-center">
                    <h2>Guest User?</h2>
                    <p>If you placed an order as a guest, you can look up your order using the Order ID from your confirmation email.</p>
                    <button 
                        className="guest-lookup-btn rounded-[6px] border-none bg-slider px-[24px] py-[12px] text-[1rem] font-[600] text-bg transition-all duration-300 hover:-translate-y-[1px] hover:bg-post-heading"
                        onClick={() => setShowGuestForm(true)}
                    >
                        Search Order
                    </button>
                </div>

                <div className="login-prompt rounded-[8px] border border-[#bbdefb] bg-[#e3f2fd] p-[2rem] text-center">
                    <h3>Have an Account?</h3>
                    <p>Sign in to view your complete order history and get updates on all your orders.</p>
                    <a href="/login" className="login-link inline-block rounded-[6px] bg-[#2196f3] px-[20px] py-[10px] font-[600] text-white no-underline transition-colors duration-300 hover:bg-[#1976d2]">Sign In</a>
                </div>
            </div>
        );
    }

    return (
        <div className="order-history-container mx-auto my-[4rem] w-[95%] max-w-[1000px] box-border rounded-[12px] bg-bg p-[2rem] max-[767px]:my-[5rem] max-[767px]:p-[1rem]">
            <div className="history-header mb-[3rem] text-center">
                <h1>Order History</h1>
                <p>View your order details and track delivery status</p>
            </div>

            {!user && showGuestForm && (
                <div className="guest-lookup-section mb-[2rem] rounded-[8px] bg-bg p-[2rem]">
                    <h2>Search Order</h2>
                    <p>Enter your Order ID from the confirmation email to view order details.</p>
                    
                    <form onSubmit={fetchGuestOrder} className="guest-lookup-form mb-[1.5rem] flex items-end gap-[1rem] max-[767px]:flex-col max-[767px]:items-stretch">
                        <div className="form-group flex-1">
                            <label htmlFor="orderId">Order ID:</label>
                            <input
                                type="text"
                                id="orderId"
                                value={guestOrderId}
                                onChange={(e) => setGuestOrderId(e.target.value)}
                                placeholder="e.g., ORDER_1234567890_abc123"
                                className="order-id-input w-full rounded-[6px] border-2 border-[#e9ecef] px-[16px] py-[12px] text-[1rem] transition-colors duration-300 focus:border-slider focus:outline-none"
                                required
                            />
                        </div>
                        <button 
                            type="submit" 
                            className="lookup-button h-fit whitespace-nowrap rounded-[6px] border-none bg-slider px-[24px] py-[12px] text-[1rem] font-[600] text-bg transition-all duration-300 hover:-translate-y-[1px] hover:bg-post-heading disabled:cursor-not-allowed disabled:opacity-60 max-[767px]:self-center"
                            disabled={loading}
                        >
                            {loading ? 'Looking Up...' : 'Search'}
                        </button>
                    </form>

                    <button 
                        className="back-btn mb-[1rem] rounded-[6px] border-none bg-bg px-[20px] py-[10px] text-[0.9rem] text-text transition-all duration-300 hover:bg-text hover:text-bg"
                        onClick={() => {
                            setShowGuestForm(false);
                            setGuestOrderId('');
                            setGuestOrder(null);
                            setError(null);
                            setGuestActiveTab('orders');
                        }}
                    >
                        ← Back to Options
                    </button>

                    {error && (
                        <div className="error-message mb-[1rem] rounded-[6px] border border-[#f5c6cb] bg-[#f8d7da] p-[1rem] text-[#721c24]">
                            <p>{error}</p>
                        </div>
                    )}

                    {guestOrder && (() => {
                        const statusLower = guestOrder.orderStatus ? guestOrder.orderStatus.toLowerCase() : '';
                        const paymentStatusLower = (guestOrder.payment && guestOrder.payment.status) ? guestOrder.payment.status.toLowerCase() : '';
                        const isPaid = ['confirmed', 'paid', 'delivered'].includes(statusLower) || ['paid'].includes(paymentStatusLower);
                        
                        // Robust digital detection: check populated productId OR the product's own productType
                        const isDigitalProduct = (p) => {
                            const pd = p.productId;
                            // Case 1: productId is populated (is an object with productType)
                            if (pd && typeof pd === 'object' && pd.productType === 'digital') return true;
                            // Case 2: productType stored directly on the order product
                            if (p.productType === 'digital') return true;
                            return false;
                        };
                        
                        const hasDigital = isPaid && guestOrder.products && guestOrder.products.some(isDigitalProduct);

                        const guestDigitalProducts = hasDigital ? guestOrder.products
                            .filter(isDigitalProduct)
                            .map((p, index) => {
                                const pd = (p.productId && typeof p.productId === 'object') ? p.productId : {};
                                return {
                                    displayData: pd,
                                    purchaseDate: guestOrder.createdAt,
                                    orderId: guestOrder.orderId,
                                    title: pd.title || p.title
                                };
                            }) : [];

                        return (
                            <div className="guest-order-result mt-[2rem]">
                                <div className="history-tabs mb-[2rem] flex justify-center gap-[1rem] border-b border-transparent pb-[1rem]">
                                    <button
                                        className={`tab-btn relative border-none bg-none px-[1rem] py-[0.5rem] text-[1.1rem] font-[600] transition-colors duration-300 ${guestActiveTab === 'orders' ? 'active text-post-heading' : 'text-text hover:text-post-heading'}`}
                                        onClick={() => setGuestActiveTab('orders')}
                                    >
                                        Order Receipt
                                    </button>
                                    {hasDigital && (
                                        <button
                                            className={`tab-btn relative border-none bg-none px-[1rem] py-[0.5rem] text-[1.1rem] font-[600] transition-colors duration-300 ${guestActiveTab === 'digital' ? 'active text-post-heading' : 'text-text hover:text-post-heading'}`}
                                            onClick={() => setGuestActiveTab('digital')}
                                        >
                                            Digital Owned Products
                                        </button>
                                    )}
                                </div>

                                {guestActiveTab === 'orders' ? (
                                    <div className="orders-grid mt-[2rem] grid w-full gap-[1.5rem] [grid-template-columns:1fr]" style={{ gridTemplateColumns: '1fr' }}>
                                        {renderTrackingDisplay()}
                                        {renderOrderDetails(guestOrder, true)}
                                    </div>
                                ) : (
                                    <div className="all-product-area mx-auto grid w-full max-w-full gap-[1.5rem] p-[1.5rem] box-border">
                                        {guestDigitalProducts.map((item, index) => (
                                            <div 
                                                key={index}
                                                id={`product-${item.displayData._id}`}
                                                className={highlightedProductId === item.displayData._id ? 'highlight-wrapper' : ''}
                                            >
                                                <DigitalProductCard
                                                    key={index}
                                                    item={item}
                                                    handleDownload={handleDownload}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        );
                    })()}
                </div>
            )}

            {user && (
                <>
                    <div className="history-tabs">
                        <button 
                            className={`tab-btn relative border-none bg-none px-[1rem] py-[0.5rem] text-[1.1rem] font-[600] transition-colors duration-300 ${activeTab === 'orders' ? 'active text-post-heading' : 'text-text hover:text-post-heading'}`}
                            onClick={() => setActiveTab('orders')}
                        >
                            Order History
                        </button>
                        <button 
                            className={`tab-btn relative border-none bg-none px-[1rem] py-[0.5rem] text-[1.1rem] font-[600] transition-colors duration-300 ${activeTab === 'digital' ? 'active text-post-heading' : 'text-text hover:text-post-heading'}`}
                            onClick={() => setActiveTab('digital')}
                        >
                            Digital Owned Products
                        </button>
                    </div>

                    {activeTab === 'orders' && (
                        <>
                            {renderTrackingDisplay()}
                            <div className="receipt-sort mb-[0.5rem] flex justify-end">
                                <label className="sort-label flex cursor-pointer select-none items-center gap-[0.5rem] font-['Courier_New',Courier,monospace] text-[0.85rem] text-[#555]">
                                    <span>Show all receipts</span>
                                    <input 
                                        type="checkbox" 
                                        checked={showAllReceipts} 
                                        onChange={(e) => setShowAllReceipts(e.target.checked)} 
                                    />
                                </label>
                            </div>
                        </>
                    )}

                    {loading ? (
                        <div className="loading-message p-[3rem] text-center text-text">
                            <p>Loading your data...</p>
                        </div>
                    ) : error ? (
                        <div className="error-message mb-[1rem] rounded-[6px] border border-[#f5c6cb] bg-[#f8d7da] p-[1rem] text-[#721c24]">
                            <p>{error}</p>
                            <button onClick={fetchUserOrders} className="retry-button mt-[1rem] rounded-[6px] border-none bg-slider px-[20px] py-[10px] text-[0.9rem] text-bg transition-colors duration-300 hover:bg-post-heading">
                                Try Again
                            </button>
                        </div>
                    ) : (
                        <div className="tab-content mt-[0.5rem] animate-[fadeIn_0.3s_ease]">
                {activeTab === 'orders' ? (
                                (() => {
                                    const filteredOrders = showAllReceipts 
                                        ? orders 
                                        : orders.filter(o => ['confirmed', 'paid', 'delivered'].includes((o.orderStatus || '').toLowerCase()));
                                    return filteredOrders.length > 0 ? (
                                    <div className="orders-grid mt-[2rem] grid w-full gap-[1.5rem] grid-cols-1 min-[768px]:grid-cols-2 min-[1025px]:grid-cols-3">
                                        {filteredOrders.map(order => renderOrderDetails(order, false))}
                                    </div>
                                ) : (
                                    <div className="no-orders p-[3rem] text-center text-text">
                                        <h2>No Orders Yet</h2>
                                        <p>You haven't placed any orders yet.</p>
                                        <a href="/store" className="shop-now-btn inline-block rounded-[6px] bg-slider px-[24px] py-[12px] font-[600] text-bg no-underline transition-all duration-300 hover:-translate-y-[1px] hover:bg-post-heading">Shop Now</a>
                                    </div>
                                    );
                                })()
                            ) : (
                                renderDigitalProducts()
                            )}
                        </div>
                    )}
                    {/* Render Modal */}
                    {renderDownloadModal()}
                </>
            )}
            {/* Render Modal for guest view */}
            {!user && renderDownloadModal()}
        </div>
    );
};

export default OrderHistory;

